import { AnimatedSvgIds, TestIds } from './constants';

export const addAttributesToStringSvg = (
  svgContent: string,
  duration: number,
) => {
  return svgContent
    .replace(
      new RegExp(
        `(<svg[^>]*data-animate-id=["']${AnimatedSvgIds.animatedSvg}["'])`,
        'g',
      ),
      `$1 data-testid="${TestIds.animatedSvg}"`,
    )
    .replace(
      new RegExp(
        `(<animate[^>]*data-animate-id=["']${AnimatedSvgIds.animateTagForward}["'])`,
        'g',
      ),
      `$1 data-testid="${TestIds.animateTagForward}"`,
    )
    .replace(
      new RegExp(
        `(<animate[^>]*data-animate-id=["']${AnimatedSvgIds.animateTagBackward}["'])`,
        'g',
      ),
      `$1 data-testid="${TestIds.animateTagBackward}"`,
    )
    .replace(
      /(dur=")[^"]*(")/g,
      `$1${duration}s"${' calcMode="spline" keyTimes="0; 1" keySplines="0.65 0 0.35 1"'}`,
    );
};
